package fr.frux

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Close
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.frux.app.resources.Res
import fr.frux.app.resources.storage_unavailable_dismiss
import fr.frux.app.resources.storage_unavailable_notice
import fr.frux.core.designsystem.theme.FruxSpacing
import org.jetbrains.compose.resources.stringResource

/**
 * Stockage du navigateur refusé (#610) : l'app tourne sur un repli en mémoire et oubliera session
 * et préférences au rechargement. Sans ce bandeau, la reconnexion exigée à chaque visite
 * passerait pour un bug.
 */
@Composable
internal fun StorageUnavailableNotice(
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier =
            modifier
                .windowInsetsPadding(WindowInsets.safeDrawing)
                .padding(FruxSpacing.md)
                .widthIn(max = 560.dp),
        shape = MaterialTheme.shapes.large,
        color = MaterialTheme.colorScheme.surface,
        contentColor = MaterialTheme.colorScheme.onSurfaceVariant,
        shadowElevation = 4.dp,
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = stringResource(Res.string.storage_unavailable_notice),
                style = MaterialTheme.typography.bodyMedium,
                modifier =
                    Modifier
                        .weight(1f)
                        .padding(start = FruxSpacing.md, top = FruxSpacing.sm, bottom = FruxSpacing.sm),
            )
            IconButton(onClick = onDismiss) {
                Icon(
                    imageVector = Icons.Outlined.Close,
                    contentDescription = stringResource(Res.string.storage_unavailable_dismiss),
                )
            }
        }
    }
}
